import { Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { useCrmManagementReadOnly } from "app/pages/sales-intelligence/hooks/useCrmManagementReadOnly";
import { CRM_ENRICHMENT_CONTENT_ID } from "app/pages/sales-intelligence/modules/crm-enrichment/constants";
import { MAX_JOBS_QUANTITY } from "app/pages/sales-intelligence/pages/manage-integration/constants/enrichment";
import { StyledTooltipTextShort } from "app/pages/sales-intelligence/pages/manage-integration/styles/styles";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

import CreateJobButton from "../CreateJobButton/CreateJobButton";

type Props = {
    integration: Integration;
    isTooltipEnabled: boolean;
    jobNumberLimit?: number;
    isCreateJobDisabled: boolean;
    onCreateJob: VoidFunction;
};

const EnrichmentSectionActions = ({
    integration,
    jobNumberLimit = MAX_JOBS_QUANTITY,
    isTooltipEnabled,
    isCreateJobDisabled,
    onCreateJob,
}: Props) => {
    const contentId = CRM_ENRICHMENT_CONTENT_ID[integration];
    const { isReadOnly } = useCrmManagementReadOnly();

    return (
        <Tooltip
            enabled={isTooltipEnabled && !isReadOnly}
            content={
                <StyledTooltipTextShort>
                    {translate(`si.crm-enrichment.${contentId}.limit.tooltip`, { limit: jobNumberLimit })}
                </StyledTooltipTextShort>
            }
        >
            <div>
                <CreateJobButton
                    type="flat"
                    isDisabled={isCreateJobDisabled}
                    onClick={onCreateJob}
                />
            </div>
        </Tooltip>
    );
};

export default EnrichmentSectionActions;
